module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-1d14a177e556cf69374ab4bc6b77e06f.webp";